<div>RESOURCE CENTRE</div>
@if (parentContentEnabled) {
    <div [innerHTML]="parentHelpContent"></div>
}
@if (subParentContentEnabled) {
    <div [innerHTML]="subParentHelpContent"></div>
}
<div [innerHTML]="helpContent"></div>
